export default {
  RH: {
    SHOW_REPORT_BODY: 'SHOW_REPORT_BODY',
    UPDATE_COMPLETE: 'UPDATE_COMPLETE',
  },
  PHOTO: {
    SELECTOR_RESET: 'PHOTO.SELECTOR_RESET',
  },
}
